module.exports = __webpack_public_path__ + "img/NBL1West.837e7ebb.png";